export default __webpack_public_path__ + "static/media/img_9.cccd6943.JPG";